import { openBlock as r, createElementBlock as t, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(c, l) {
  return r(), t("svg", o, [...l[0] || (l[0] = [
    e("path", {
      fill: "currentColor",
      d: "m18 3.84-1.44 1.68-.483-.202-.642-.263-.633-.262c-2.122-.77-4.1-.597-6.162.247-2.105 1.057-3.312 2.59-4.05 4.815-.566 2.185-.273 4.066.742 6.087 1.202 1.987 2.905 3.05 5.131 3.625 2.168.424 4.156-.1 6.037-1.237 1.655-1.187 2.54-2.805 3.077-4.743.113-.687.087-1.298.043-1.992-.032-.797-.025-1.152.431-1.815.418-.415.838-.788 1.309-1.14.997.997.793 2.441.796 3.773-.049 2.66-1.162 4.888-2.956 6.825-2.344 2.24-4.854 2.926-8.024 2.893-2.634-.156-5.123-1.432-6.936-3.348-1.976-2.68-2.601-5.428-2.32-8.703.548-2.873 2.237-5.008 4.56-6.72 3.575-2.23 8.162-2.061 11.52.48"
    }, null, -1),
    e("path", {
      fill: "currentColor",
      d: "m21.12 3.12 1.68 1.44c-.457.914-.836 1.374-1.548 2.082l-.67.67-.724.717-.74.738q-.974.97-1.949 1.937-.995.988-1.988 1.978-1.95 1.941-3.901 3.878c-.798-.378-1.324-.788-1.946-1.42l-.549-.553-.565-.577-.577-.583Q6.941 12.715 6.24 12c.396-1.01.723-1.154 1.68-1.92l2.88 2.88c.858-.429 1.272-.733 1.928-1.394l.568-.568.605-.612.626-.628q.988-.992 1.973-1.988l1.34-1.346q1.642-1.65 3.28-3.304"
    }, null, -1)
  ])]);
}
const i = { render: n };
export {
  i as default,
  n as render
};
